var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStratuminline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    baseProfile: "tiny",
    viewBox: "0 0 24 24",
    className: "stratum_inline_svg__css-16t87t0",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 5V3a1 1 0 00-1-1H7a1 1 0 00-1 1v2C4.346 5 3 6.346 3 8v10c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3V8c0-1.654-1.346-3-3-3zM8 4h7v5H8V4zM6 7v3a1 1 0 001 1h9a1 1 0 001-1V7c.551 0 1 .449 1 1v2.5c0 .827-.673 1.5-1.5 1.5h-10c-.827 0-1.5-.673-1.5-1.5V8c0-.551.449-1 1-1zm11 12H6c-.551 0-1-.449-1-1v-5.513c.419.318.935.513 1.5.513h10c.565 0 1.081-.195 1.5-.513V18c0 .551-.449 1-1 1zM13.5 7h-4a.5.5 0 000 1h4a.5.5 0 000-1zm1.5 9H8a.5.5 0 000 1h7a.5.5 0 000-1zM13.5 5h-4a.5.5 0 000 1h4a.5.5 0 000-1z",
    stroke: "none"
  })));
}

export default SvgStratuminline;